import React, { useEffect, useState } from "react";
import {
  createFileRequest,
  fetchCustomerFileRequests,
} from "../../api/fileRequests";
import {
  Container,
  Box,
  Flex,
  Stack,
  Heading,
  Spacer,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Textarea,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import CustomTableContainer from "../../theme/components/tableContainer";
import { GenericModal } from "../generic/modal";

export const ClientFileRequests = ({ customer_id }) => {
  const [fileRequests, setFileRequests] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const getData = async () => {
      const fileRequestResults = fetchCustomerFileRequests(customer_id);
      setFileRequests(await fileRequestResults);
    };
    getData();
  }, [customer_id]);

  const handleCreateFileRequest = async (e, fileRequest) => {
    e.preventDefault();

    // Todo: fix this
    // adding this placeholder for now, I thought of making a dropdown of all
    // sub folders but that was a lot of requests and it took forever.
    // For now it will just upload to the root of the customers Google Drive folder.
    fileRequest.google_drive_folder_id = "todo";

    createFileRequest(customer_id, fileRequest)
      .then((res) => {
        setFileRequests((prev) => [...prev, res.data]);
        onClose();
      })
      .catch((err) => {
        console.error("Error creating file request:", err);
      });
  };

  return (
    <Container maxW="100%" bg="brand.50" h="calc(91vh)">
      <Stack direction="column" spacing={2} align="center">
        <CustomTableContainer width="100%">
          <Flex pb="5">
            <Box>
              <Heading as="h3" size="lg">
                File Requests
              </Heading>
            </Box>
            <Spacer />
            <Box>
              <Stack direction="row" spacing={6} align="center">
                <ClientFileRequestsModal
                  isOpen={isOpen}
                  onClose={onClose}
                  handleSubmit={handleCreateFileRequest}
                />
                <Button onClick={onOpen} leftIcon={<AddIcon boxSize={3} />}>
                  Create File Request
                </Button>
              </Stack>
            </Box>
          </Flex>
          <Box maxHeight="calc(100vh - 350px)" bg="white" overflowX="auto">
            <Table variant="unstyled">
              <Thead position="sticky" top={-1} zIndex={1}>
                <Tr>
                  <Th>Name</Th>
                  <Th>Description</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {fileRequests.map((fileRequest) => (
                  <Tr key={fileRequest.id}>
                    <Td>{fileRequest.name}</Td>
                    <Td>{fileRequest.description}</Td>
                    <Td>{fileRequest.status}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </CustomTableContainer>
      </Stack>
    </Container>
  );
};

const ClientFileRequestsModal = ({ isOpen, onClose, handleSubmit }) => {
  const [fileRequest, setFileRequest] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFileRequest({ ...fileRequest, [name]: value });
  };

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Create File Request`}
      submitButton={
        <Button type="submit" form="createForm" ml={3}>
          Create
        </Button>
      }
      body={
        <>
          <form
            id={"createForm"}
            onSubmit={(e) => handleSubmit(e, fileRequest)}
          >
            <FormControl>
              <FormLabel htmlFor="name">Name</FormLabel>
              <Input
                type="text"
                name="name"
                id="name"
                onChange={handleInputChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor="description">Description</FormLabel>
              <Textarea
                type="text"
                name="description"
                id="description"
                onChange={handleInputChange}
              />
            </FormControl>
          </form>
        </>
      }
    ></GenericModal>
  );
};
